module.exports = __webpack_public_path__ + "img/sence_asi_1.e351d499.png";